// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout_pageLayout__7Tv4L","main":"PageLayout_main__wzrE2","mainFull":"PageLayout_mainFull__QfEFF"};